import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiCallService } from '../../../Services/api-call-service.service';
import { ErrorhandlingService } from '../../../Services/error-handling.service';
import { LoaderService } from '../../../Services/loader-service.service';
import { ToastrService } from 'ngx-toastr';
import { GameService } from '../../../Services/game.service';

type TabValue = 'all-game' | 'quick-game' | 'hot-game' | 'upcoming-game';

@Component({
  selector: 'app-cmax-games',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cmax-games.component.html',
  styleUrl: './cmax-games.component.scss',
})
export class CmaxGamesComponent implements OnInit {
  tabs: { label: string; value: TabValue }[] = [
    { label: 'All Game', value: 'all-game' },
    // { label: 'Quick Game', value: 'quick-game' },
    { label: 'Hot Game', value: 'hot-game' },
    // { label: 'Upcoming Game', value: 'upcoming-game' },
  ];

  activeTab: TabValue = 'all-game';
  games: any[] = [];
  showAllGames: boolean = false;

  constructor(
    private router: Router,
    private apiService: ApiCallService,
    private errorHandler: ErrorhandlingService,
    private toastr: ToastrService,
    private loaderService: LoaderService,
    private gameService: GameService
  ) {}

  ngOnInit(): void {
    this.loadGames();
  }

  RedirectToLogin(): void {
    this.router.navigate(['/login']);
  }
  getGameImage(gameName: string): any {
    const gameData = [...this.gameService.getGames(),...this.gameService.SystemGames];
    const normalize = (name: string) =>
                      name?.toLowerCase() === 'Bacchrat' ? 'Baccarat' :name?.toLowerCase() === 'stackbuilder' ? 'stack builder' : name?.toLowerCase();
    const game = gameData.find((g: any) => normalize(g.name) === normalize(gameName));
    return game;
  }
  // ✅ Load games from API
  loadGames(): void {
    this.loaderService.show();

    let type: string | undefined;

    // Map tabs → API type
    switch (this.activeTab) {
      case 'quick-game':
        type = 'company';
        break;
      case 'hot-game':
        type = 'hot';
        break;
      case 'upcoming-game':
        type = 'upcoming';
        break;
      default:
        type = undefined; // all games
        break;
    }

    const endpoint = type ? `Public/GetGames?type=${type}` : `Public/GetGames`;

    this.apiService.GetCallWithoutToken(endpoint).subscribe(
      (response) => {
        if (response.responseCode === 200 && response.data) {
          this.games = response.data;
          // this.toastr.success(response.responseMessage, 'Success');
        } else {
          this.games = [];
          // this.errorHandler.handleResponseError(response);
        }
        this.loaderService.hide();
      },
      (error) => {
        // this.errorHandler.handleHttpError(error);
        this.loaderService.hide();
      }
    );
  }

  // ✅ Change tab and reload data
  onTabChange(tab: TabValue) {
    this.activeTab = tab;
    this.loadGames();
  }

  get hasMoreGames(): boolean {
    return this.games.length > this.getInitialVisibleCount();
  }

  private getInitialVisibleCount(): number {
    const w = window.innerWidth || 0;
    return w >= 1024 ? 8 : 4;
  }

  get displayedGames() {
    const filteredGames = this.games.filter(
    (g: any) => g.name?.toLowerCase() !== 'slots'
  );
    if (this.showAllGames) return filteredGames;
    const count = this.getInitialVisibleCount();
    return filteredGames.slice(0, count);
  }

  toggleShowAll() {
    this.showAllGames = !this.showAllGames;
  }
}
